<template>
  <nav class="menu bioseco">
    <div class="container">
      <div class="box">
        <div class="inside">
          <div class="menu-box">
            <ul class="main-menu">
              <router-link tag="li" active-class="active" to="/" exact>
                <a><span @click="menuClicked">{{$t('menu.home')}}</span></a>
              </router-link>
              <router-link tag="li" class="submenu" active-class="active" to="/products">
                <a><span @click="menuClicked">{{$t('menu.products.title')}}</span></a>
                <ul>
                  <router-link tag="li" active-class="active" to="/products/farms">
                    <a><span @click="menuClicked">{{$t('menu.products.farms')}}</span></a>
                  </router-link>
                  <router-link tag="li" active-class="active" to="/products/airport">
                    <a><span @click="menuClicked">{{$t('menu.products.airports')}}</span></a>
                  </router-link>
                  <router-link tag="li" active-class="active" to="/products/area">
                    <a><span @click="menuClicked">{{$t('menu.products.ornithologists')}}</span></a>
                  </router-link>
                </ul>
              </router-link>
              <router-link tag="li" active-class="active" to="/infonews">
                <a><span @click="menuClicked">{{$t('menu.news')}}</span></a>
              </router-link>

              <router-link tag="li" active-class="active" to="/certificates">
                <a><span @click="menuClicked">{{$t('menu.certs')}}</span></a>
              </router-link>
              
              <router-link tag="li" active-class="active" to="/awards">
                <a><span @click="menuClicked">{{$t('menu.awards')}}</span></a>
              </router-link>

              <router-link tag="li" class="submenu disabled" active-class="active" to="/grants" :event="''">
                <a><span @click="menuClicked">{{$t('menu.grants.title')}}</span></a>
                <ul>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/bps">
                      <a><span @click="menuClicked">{{$t('menu.grants.bps')}}</span></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/afms">
                      <a><span @click="menuClicked">{{$t('menu.grants.afms')}}</span></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/bridgealfa">
                      <a><span @click="menuClicked">{{$t('menu.grants.ba')}}</span></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/pmt">
                    <a><span @click="menuClicked">{{$t('menu.grants.pmt')}}</span></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/eic">
                      <a><span @click="menuClicked" v-html="$t('menu.grants.eic')"/></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/bps2">
                      <a><span @click="menuClicked" v-html="$t('menu.grants.bps2')"/></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/pbe">
                      <a><span @click="menuClicked" v-html="$t('menu.grants.pbe')"/></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/pbe2">
                      <a><span @click="menuClicked" v-html="$t('menu.grants.pbe2')"/></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/ppbb">
                      <a><span @click="menuClicked" v-html="$t('menu.grants.ppbb')"/></a>
                    </router-link>
                  </li>
                  <li>
                    <router-link tag="li" active-class="active" to="/grants/offshore">
                      <a><span @click="menuClicked" v-html="$t('menu.grants.offshore')"/></a>
                    </router-link>
                  </li>
                </ul>
              </router-link>

              <router-link tag="li" active-class="active" to="/about">
                <a><span @click="menuClicked">{{$t('menu.about')}}</span></a>
              </router-link>
              <router-link tag="li" active-class="active" to="/contact">
                <a><span @click="menuClicked">{{$t('menu.contact')}}</span></a>
              </router-link>
              <li><a @click="showModal()">{{$t('menu.ask')}}</a></li>

            </ul>
          </div>
          <div class="menu-box">
            <ul class="lang-menu">
              <li v-bind:class="{'active' : lang === 'en'}"><a @click="setLang('en')">{{$t('menu.english')}}</a></li>
              <li v-bind:class="{'active' : lang === 'pl'}"><a @click="setLang('pl')">{{$t('menu.polish')}}</a></li>
            </ul>
            <!--            <router-link tag="div" to="/projects">-->
            <!--              <a><span class="btn-projects" @click="menuClicked">{{$t('menu.project')}}</span></a>-->
            <!--            </router-link>-->
            <a href="https://www.facebook.com/Bioseco-497515667013273/" target="_blank" class="fb-icon"></a>
            <a href="https://pl.linkedin.com/company/bioseco/" target="_blank" class="linked-icon"></a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import store from '../store/store'

  export default {
    name: 'main-menu',
    data() {
      return {}
    },
    methods: {
      menuClicked: function () {
        this.$store.commit('SET_MODAL', { visible: false, questionName: '' });
        this.$store.commit('CLOSE_MENU');
      },
      setLang: function (lang) {
        const title = this.$route.meta.title;
        // const title = lang[store.state.lang]['page_titles'][to.meta.title];
        // document.title = title ? title : document.title;

        store.commit('SET_LANG', lang);
        store.commit('TOGGLE_MENU');
        if (this.$route.meta.title) {
          document.title = this.$t('page_titles.' + title);
        }
      },
      showModal: function () {
        store.commit('SET_MODAL', {visible: true, questionName: ''});
      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      }
    }
  }
</script>
<style>
  .btn-projects {
    color: #6d6d6d;
    margin-top: 20px;
    display: block;
  }

  .menu .main-menu li ul li {
    width: 600px;
  }
  .bioseco.menu .main-menu li a{
    font-size: 32px;
    line-height: 55px;
  }
  .bioseco.menu .main-menu li ul li a{
    font-size: 18px;
    line-height: 34px;
  }
  .bioseco.menu .main-menu li.disabled > a{
    cursor: default;
  }
</style>



// WEBPACK FOOTER //
// Menu.vue?357feabb